import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  Grid,
  TextField,
  useMediaQuery,
  Typography,
  Tab,
  Tabs,
  Checkbox,
} from '@mui/material';
import { useFirebase, useFirestore } from 'react-redux-firebase';
import collections from '../constants/FirestoreCollections';
import { useDispatch, useSelector } from 'react-redux';
import { lastIndexOf, isUndefined } from 'lodash';
import { actions } from '../actions';
import QRCode from 'qrcode.react';
import { makeStyles } from '@mui/styles';
import { a11yProps } from '../utils/utils';

const useStyles = (small) => {
  return makeStyles((theme) => ({
    configuration: {
      paddingTop: '72px',
    },
    title: {
      fontSize: theme.sizes.md.t3,
    },
    message: {
      width: '100%',
      '&::-webkit-scrollbar': {
        width: '.5em',
      },
      '&::-webkit-scrollbar-track': {
        '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,.2)',
      },
    },
    formControl: {
      margin: '16px 0',
    },
    colorForm: {
      width: 'min-content',
      marginLeft: 32,
      position: 'relative',
    },
    color: {
      width: '50px',
      height: '50px',
    },
    inputColor: {
      padding: '6px 8px',
    },
    imagePrev: {
      background: '#eee',
      width: '50px',
      height: '75px',
      marginRight: '16px',
    },
    imagePrevLy: {
      display: 'flex',
      alignItems: 'center',
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    mock: {
      width: '100%',
      minHeight: '500px',
      border: '1px solid #ccc',
      boxShadow: 'none',
    },
    phoneRef: {
      fontSize: '18px',
      minWidth: 'max-content',
    },
    link: {
      color: '#3734f7',
      cursor: 'pointer',
      '&:hover': {
        color: '#6361ff',
      },
    },
    button: {
      width: 'fit-content',
      background: 'transparent',
      border: `1px solid ${theme.palette.primary.main}`,
      color: '#e3b500',
      '&:hover': {
        backgroundColor: '#eee',
        transform: 'scale(1.05)',
      },
    },
  }));
};

const Channels = () => {
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();
  const [image, setImage] = useState(null);
  const [color, setColor] = useState('');
  const [messagesWeb, setMessagesWeb] = useState([]);
  const [messagesWsp, setMessagesWsp] = useState([]);
  const [tempImage, setTempImage] = useState();
  const [section, setSection] = useState(0);
  const [refresh, setRefresh] = useState(true);

  // const [notificationTime, setNotificationTime] = useState('');
  const organization = useSelector((state) => state.app.organization);
  const profile = useSelector((state) => state.firebase.profile);
  const firebase = useFirebase();
  const firestore = useFirestore();
  const appDispatch = useDispatch();

  useEffect(() => {
    if (organization && organization.configuration) {
      setImage(organization.configuration.image);
      setColor(
        organization.configuration.mainColor ? organization.configuration.mainColor : '#000000',
      );
      setMessagesWeb(
        organization.configuration.initialMessagesWeb
          ? organization.configuration.initialMessagesWeb
          : [''],
      );
      setMessagesWsp(
        organization.configuration.initialMessagesWsp
          ? organization.configuration.initialMessagesWsp
          : [''],
      );
    }
  }, [organization]);

  const handleChangeFile = (e) => {
    setTempImage(e.target.files[0]);
    // eslint-disable-next-line no-undef
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.onloadend = () => {
      setImage(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleUpdate = async () => {
    appDispatch({
      type: actions.changeLoading,
      loading: { loading: true, priority: 1 },
    });
    const random = Math.floor(Math.random() * 10000);

    const ref = firebase.storage().ref();

    const image = organization.configuration && organization.configuration.image;
    if (image && tempImage) {
      const lastIndex = lastIndexOf(image.split(''), '/');
      let urlToRemove = image.slice(lastIndex + 1, image.indexOf('?'));
      urlToRemove = decodeURIComponent(urlToRemove);
      var desertRef = ref.child(urlToRemove);
      desertRef
        .delete()
        .then(() => {})
        .catch(() => {});
    }

    if (tempImage) {
      const route = `organizations/${random}-${tempImage.name}`;
      ref
        .child(route)
        .put(tempImage)
        .then(() => {
          ref
            .child(route)
            .getDownloadURL()
            .then((res) => {
              setImage(res);
              firestore
                .collection(collections.organizations)
                .doc(profile.organizationId)
                .update({
                  configuration: {
                    ...organization.configuration,
                    image: res,
                    mainColor: color,
                    initialMessagesWeb: messagesWeb,
                    initialMessagesWsp: messagesWsp,
                    // sendNotificationTime: notificationTime,
                  },
                })
                .then(() => {
                  setRefresh(!refresh);
                  appDispatch({
                    type: actions.changeLoading,
                    loading: { loading: false, priority: 1 },
                  });
                  appDispatch({
                    type: actions.alert,
                    alert: {
                      snackbarOpen: true,
                      snackbarMessage: '¡Actualizado exitosamente!',
                      snackbarSeverity: 'success',
                    },
                  });
                })
                .catch(() => {
                  appDispatch({
                    type: actions.changeLoading,
                    loading: { loading: false, priority: 1 },
                  });
                  appDispatch({
                    type: actions.alert,
                    alert: {
                      snackbarOpen: true,
                      snackbarMessage: 'Error al actualizar.',
                      snackbarSeverity: 'error',
                    },
                  });
                });
            });
        });
    } else {
      firestore
        .collection(collections.organizations)
        .doc(profile.organizationId)
        .update({
          configuration: {
            ...organization.configuration,
            mainColor: color,
            initialMessagesWeb: messagesWeb,
            initialMessagesWsp: messagesWsp,
            // sendNotificationTime: notificationTime,
          },
        })
        .then(() => {
          setRefresh(!refresh);
          appDispatch({
            type: actions.changeLoading,
            loading: { loading: false, priority: 1 },
          });
          appDispatch({
            type: actions.alert,
            alert: {
              snackbarOpen: true,
              snackbarMessage: '¡Actualizado exitosamente!',
              snackbarSeverity: 'success',
            },
          });
        })
        .catch(() => {
          appDispatch({
            type: actions.changeLoading,
            loading: { loading: false, priority: 1 },
          });
          appDispatch({
            type: actions.alert,
            alert: {
              snackbarOpen: true,
              snackbarMessage: 'Error al actualizar.',
              snackbarSeverity: 'error',
            },
          });
        });
    }
  };
  const setBussinesRule = (data) => {
    appDispatch({
      type: actions.changeLoading,
      loading: { loading: true, priority: 1 },
    });
    firestore
      .collection(collections.organizations)
      .doc(organization.id)
      .update({ 'businessRules.requireContact': data })
      .catch(() => {
        appDispatch({
          type: actions.alert,
          alert: {
            snackbarOpen: true,
            snackbarMessage: 'Error al actualizar.',
            snackbarSeverity: 'error',
          },
        });
      })
      .finally(() => {
        appDispatch({
          type: actions.changeLoading,
          loading: { loading: false, priority: 1 },
        });
      });
  };

  const refreshIFrame = () => {
    const iframe = document.getElementById('FrameID');
    if (iframe) iframe.src = `${process.env.REACT_APP_URL}/?id=${organization.id}&disabled=true`;
  };

  const downloadQR = (qrid) => {
    const canvas = document.getElementById(qrid);
    const pngUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
    const downloadLink = document.createElement('a');
    downloadLink.href = pngUrl;
    downloadLink.download = 'whatsappQR.png';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const handleCopy = (target, ref) => {
    navigator.clipboard.writeText(target);
    appDispatch({
      type: actions.alert,
      alert: {
        snackbarOpen: true,
        snackbarMessage: `Se ha copiado ${ref} en su portapapeles.`,
        snackbarSeverity: 'info',
      },
    });
  };

  useEffect(() => {
    refreshIFrame();
  }, [organization.id, refresh]);

  const myRef = useRef(null);

  const phone = (organization && organization.provider && organization.provider.phone) || '';

  return (
    <>
      <Tabs
        value={section}
        onChange={(_, newValue) => setSection(newValue)}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
        className={classes.tabs}
      >
        <Tab label="Webchat" {...a11yProps(0)} />
        <Tab label="Whatsapp" {...a11yProps(1)} />
        <Tab label="Codigo QR" {...a11yProps(2)} />
      </Tabs>
      {section === 0 && (
        <Box py={2} display="flex" flexDirection={small && 'column'}>
          <Grid item sm={6}>
            <Grid item sm={12} className={classes.imagePrevLy}>
              <Grid item sm={2} className={classes.imagePrev}>
                {image && <img className={classes.image} src={image} />}
              </Grid>
              <Grid item sm={8}>
                <FormControl className={classes.formControl} fullWidth>
                  <span>Imagen</span>
                  <TextField
                    id="standard-basic"
                    onChange={handleChangeFile}
                    type="file"
                    variant="outlined"
                  />
                </FormControl>
              </Grid>
              <FormControl className={`${classes.colorForm} ${classes.formControl}`} fullWidth>
                <Typography sx={{ fontSize: 12 }}>Color</Typography>
                <Box
                  sx={{ width: 35, height: 35, background: color, borderRadius: 2 }}
                  onClick={() => myRef.current.click()}
                />
                <input
                  onChange={(e) => setColor(e.target.value)}
                  style={{ position: 'absolute', opacity: 0 }}
                  type="color"
                  ref={myRef}
                />
              </FormControl>
            </Grid>
            <Grid item sm={12}>
              <FormControl className={classes.formControl} fullWidth>
                <span>Mensaje de inicio del webchat (entre * para marcar en negrita)</span>
                {messagesWeb.map((e, index) => (
                  <Box key={index} py={2} width="100%">
                    <TextField
                      id="outlined-multiline-static"
                      multiline
                      inputProps={{ className: classes.message }}
                      value={e}
                      style={{ width: '100%' }}
                      onChange={(event) =>
                        setMessagesWeb(
                          messagesWeb.map((item, i) => (i === index ? event.target.value : item)),
                        )
                      }
                      rows={6}
                      variant="outlined"
                      spellCheck="false"
                    />
                  </Box>
                ))}
              </FormControl>
            </Grid>
            {organization &&
              organization.healthSoftware &&
              organization.healthSoftware.name === 'decisionTree' && (
                <Box mb={2} display="flex" flexDirection="column">
                  <Box mt={1}>
                    <Typography>
                      <span className={classes.checkboxLabel}>Requiere contacto obligatorio</span>
                    </Typography>
                    <Checkbox
                      checked={
                        organization &&
                        organization.businessRules &&
                        !isUndefined(organization.businessRules.requireContact)
                          ? !!organization.businessRules.requireContact
                          : false
                      }
                      onChange={() =>
                        setBussinesRule(
                          organization.businessRules.requireContact
                            ? !organization.businessRules.requireContact
                            : true,
                        )
                      }
                    />
                  </Box>
                </Box>
              )}
            <Box mb={4} display="flex">
              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                onClick={handleUpdate}
              >
                Guardar
              </Button>
              <Box ml={2}>
                <Button
                  className={classes.button}
                  variant="contained"
                  color="primary"
                  onClick={() => setMessagesWeb([...messagesWeb, ''])}
                >
                  +
                </Button>
              </Box>
              {messagesWeb && messagesWeb.length > 1 && (
                <Box ml={2}>
                  <Button
                    className={classes.button}
                    variant="contained"
                    color="primary"
                    onClick={() => setMessagesWeb(messagesWeb.slice(0, messagesWeb.length - 1))}
                  >
                    -
                  </Button>
                </Box>
              )}
            </Box>
            <Box display="flex" flexDirection="column">
              <Box mt={1}>
                <Typography className={classes.phoneRef}>
                  URL:{' '}
                  <a
                    href={`${process.env.REACT_APP_URL}/?id=${organization.id}`}
                    target="__blank"
                    className={classes.link}
                  >
                    {`${process.env.REACT_APP_URL}/?id=${organization.id}`}
                  </a>
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Box
            display="flex"
            justifyContent="center"
            sx={{ minWidth: 500, maxWidth: '100%', m: '0 auto' }}
          >
            <iframe
              id="FrameID"
              className={classes.mock}
              src={`${process.env.REACT_APP_URL}/?id=${organization.id}&disabled=true`}
            />
          </Box>
        </Box>
      )}
      {section === 1 && (
        <Box py={2}>
          <Box display="flex">
            <Box display="flex" flexDirection="column">
              <Box mt={1}>
                <Typography className={classes.phoneRef}>
                  Telefono:{' '}
                  <span onClick={() => handleCopy(phone, 'el celular')} className={classes.link}>
                    {phone}
                  </span>
                </Typography>
              </Box>
            </Box>
          </Box>
          <Grid item sm={12}>
            <FormControl className={classes.formControl} fullWidth>
              <span>Mensaje de inicio de whatsapp (entre * para marcar en negrita)</span>
              {messagesWsp &&
                messagesWsp.map((message, index) => (
                  <Box key={index} py={2} width="100%">
                    <TextField
                      id="outlined-multiline-static"
                      multiline
                      inputProps={{ className: classes.message }}
                      value={message}
                      style={{ width: '100%' }}
                      onChange={(event) => {
                        setMessagesWsp(
                          messagesWsp.map((item, i) => (i === index ? event.target.value : item)),
                        );
                      }}
                      rows={6}
                      variant="outlined"
                      spellCheck="false"
                    />
                  </Box>
                ))}
            </FormControl>
          </Grid>
          <Box mb={4} display="flex">
            <Box display="flex">
              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                onClick={handleUpdate}
              >
                Guardar
              </Button>
              <Box ml={2}>
                <Button
                  className={classes.button}
                  variant="contained"
                  color="primary"
                  onClick={() => setMessagesWsp([...messagesWsp, ''])}
                >
                  +
                </Button>
              </Box>
              {messagesWsp && messagesWsp.length > 1 && (
                <Box ml={2}>
                  <Button
                    className={classes.button}
                    variant="contained"
                    color="primary"
                    onClick={() => setMessagesWsp(messagesWsp.slice(0, messagesWsp.length - 1))}
                  >
                    -
                  </Button>
                </Box>
              )}
            </Box>
          </Box>
          <Box mb={4} />
        </Box>
      )}
      {section === 2 && (
        <Box display="flex" py={2}>
          <Box display="flex" flexDirection="column">
            <Box mt={1} display="flex" justifyContent="center">
              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                onClick={() => downloadQR('qrID1')}
              >
                DESCARGAR QR (WHATSAPP)
              </Button>
            </Box>
            <QRCode
              id="qrID1"
              value={`https://api.whatsapp.com/send?text=&phone=${phone}`}
              size={290}
              level="H"
              includeMargin
            />
          </Box>
          <Box display="flex" flexDirection="column" ml={16}>
            <Box mt={1} display="flex" justifyContent="center">
              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                onClick={() => downloadQR('qrID2')}
              >
                DESCARGAR QR (WEBCHAT)
              </Button>
            </Box>
            <QRCode
              id="qrID2"
              value={`${process.env.REACT_APP_URL}/?id=${organization.id}`}
              size={290}
              level="H"
              includeMargin
            />
          </Box>
        </Box>
      )}
    </>
  );
};

const Props = {};

Channels.propTypes = Props;

export default Channels;
